"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Facepile_base_1 = require("./Facepile.base");
var Facepile_styles_1 = require("./Facepile.styles");
/**
 * Facepile description
 */
exports.Facepile = Utilities_1.styled(Facepile_base_1.FacepileBase, Facepile_styles_1.getStyles);
//# sourceMappingURL=Facepile.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Facepile/Facepile.js
// module id = 1545
// module chunks = 0